import styled, { css } from 'styled-components';
import { Box, spacing } from '@landr/maestro';

const actionsBaseStyles = css`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: ${spacing('sm')};
`;

export const Actions = styled(Box)`
    ${actionsBaseStyles};
`;
